import { useCountryContext } from '../../presentation/screens/design-editor2/contexts/country.context'

export function getCountryDisplayNameOrUndefined(code: string): string | undefined {
    const { countries } = useCountryContext()

    return countries.find(x => code === x.code)?.name
}